import { Injectable } from '@angular/core';
import { ApiService } from '../../auth-o3/shared/services/api.service';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RecordWorkflowService {
  constructor(private apiService: ApiService) {}

  async getNextWorkflowStates(currentState: string): Promise<string[]> {
    const nextStates = (await this.apiService
      .getWithParams(
        `state-transitions`,
        {
          workflow: 'Product record workflow',
          fromState: currentState,
        },
        environment.api.workflow
      )
      .toPromise()) as { to_state: string }[];

    return nextStates.map(({ to_state }) => to_state);
  }
}
